// extracted by mini-css-extract-plugin
export default {"mainContent":"LayoutOutside_mainContent__IDSNn"};